/**
 * Языки интерфейса — в кодах BCP-47, потому что их понимает `Intl.PluralRules`.
 * Пока язык назывался `RUSSIAN`, i18next не мог получить правило множественного
 * числа и молча брал английское: «5 вопроса» вместо «5 вопросов».
 *
 * Это НЕ то же самое, что локали колод. Там коды приходят с бэкенда
 * (`ENGLISH_GB`, `RUSSIAN`) и остаются как есть — они часть его контракта.
 */
export const DEFAULT_LANGUAGE = 'en-GB';

export const SUPPORTED_LANGUAGES = [
    'en-GB',
    'en-US',
    'ru-RU',
    'es-ES',
    'de-DE',
    'fr-FR',
    'pl-PL',
    'zh-CN',
    'it-IT',
];

/**
 * Приводит что угодно к поддерживаемому коду: незнакомое значение — в язык
 * по умолчанию. Вызывается на чтении из localStorage (`detection`
 * в `i18n/index.js`), поэтому чинит и то, что уже лежит в браузере.
 *
 * Карты старых имён (`RUSSIAN` -> `ru-RU`) здесь больше нет: она разбирала
 * значения из среза redux-persist, а язык интерфейса в redux не хранится
 * с 2026-09-02. У людей, выбиравших язык до этого, он один раз сбросится
 * на английский — так решено сознательно, чтобы не тащить чтение чужого
 * формата хранения ради одного релиза.
 */
export const normalizeLanguage = (language) => {
    return SUPPORTED_LANGUAGES.includes(language) ? language : DEFAULT_LANGUAGE;
};
